import "./nordic.ts";

/** Blog post: scroll-spy TOC, reading-progress bar, and a copy-link button. */

const article = document.getElementById("article");
const links = Array.from(document.querySelectorAll<HTMLAnchorElement>("#toc a"));
const heads = links.map((a) => document.getElementById((a.getAttribute("href") ?? "").slice(1)));
const pbar = document.getElementById("pbar");
const pct = document.getElementById("pct");

// ---- scroll-spy via IntersectionObserver ----
if ("IntersectionObserver" in window) {
  const spy = new IntersectionObserver(
    (entries) => {
      for (const en of entries) {
        if (en.isIntersecting) {
          const id = en.target.id;
          for (const a of links) a.classList.toggle("active", a.getAttribute("href") === `#${id}`);
        }
      }
    },
    { rootMargin: "-20% 0px -70% 0px", threshold: 0 },
  );
  for (const h of heads) if (h) spy.observe(h);
}

// ---- reading progress ----
const onScroll = () => {
  if (!article || !pbar || !pct) return;
  const rect = article.getBoundingClientRect();
  const total = article.offsetHeight - window.innerHeight;
  const done = Math.min(1, Math.max(0, -rect.top / (total > 0 ? total : 1)));
  const p = Math.round(done * 100);
  pbar.style.width = `${p}%`;
  pct.textContent = `${p}%`;
};
onScroll();
window.addEventListener("scroll", onScroll, { passive: true });

// ---- copy link ----
const copyBtn = document.getElementById("copyLink");
if (copyBtn) {
  copyBtn.addEventListener("click", () => {
    const original = copyBtn.innerHTML;
    const done = () => {
      copyBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="#2fe6c4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
      setTimeout(() => {
        copyBtn.innerHTML = original;
      }, 1600);
    };
    if (navigator.clipboard?.writeText) navigator.clipboard.writeText(window.location.href).then(done).catch(done);
    else done();
  });
}
